import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App.tsx';
import { createBaseStore } from 'sama-shared';
import { createPersistConfig } from 'sama-shared/store/persistConfig';
import tenantReducer from './features/tenant/slices/tenantSlice';
import './index.css';

const tenantPersistConfig = createPersistConfig('tenant', ['activeViewTab']);

const { store, persistor } = createBaseStore(
  { tenant: tenantReducer },
  { tenant: tenantPersistConfig }
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </StrictMode>
);
